import React from "react";

const DIMENSION_LABELS = {
  heritage: "Héritage",
  innovation: "Innovation",
  plaisir: "Plaisir",
  esthetique: "Esthétique",
  conceptuel: "Conceptuel",
  emotionnel: "Émotionnel",
  social: "Social",
  individuel: "Individuel",
  investissement: "Investissement",
};

const BAR_COLORS = [
  "bg-blue-500", "bg-pink-500", "bg-green-500", "bg-yellow-500", "bg-purple-500",
  "bg-red-500", "bg-teal-500", "bg-orange-500", "bg-indigo-500",
];

/**
 * Affiche les 9 dimensions psychologiques réelles du profil héritier
 * (modèle canonique, cf. matchingArchetypes.js) sous forme de jauges.
 * @param {Object} dims - Ex: { heritage: 70, innovation: 85, ... }
 */
export default function ProfilCanvas({ dims }) {
  if (!dims) return null;

  const entries = Object.keys(DIMENSION_LABELS).filter((key) => key in dims);

  return (
    <div className="mb-6 grid grid-cols-2 gap-4 bg-white rounded-lg shadow p-4">
      {entries.map((key, i) => (
        <div key={key}>
          <div className="font-semibold mb-1">{DIMENSION_LABELS[key]}</div>
          <div className="w-full bg-gray-200 rounded-full h-3">
            <div
              style={{ width: `${dims[key]}%` }}
              className={`${BAR_COLORS[i % BAR_COLORS.length]} h-3 rounded-full transition-all duration-500`}
            />
          </div>
          <div className="text-xs text-gray-500 mt-1">{dims[key]} / 100</div>
        </div>
      ))}
    </div>
  );
}
